export default [
  {
    path: "/bff/login",
    component: () => import("@/views/pages/User/Login.vue"),
    meta: {
      guest: true,
      requiresAuth: false,
    },
  },
  {
    name: "companySelection",
    path: "/company-selection",
    component: () => import("@/views/pages/User/CompanySelection.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];
